import styled from 'styled-components';

const Wrapper = styled.div`
	padding: 22px 51px;
	.user-info {
		background-color: #212121;
      	padding: 2rem 3rem;
		font-size: 16px;
		a {
			text-decoration: none;
			background-color: transparent;
		}
		.ant-btn-primary {
			width: 180px;
			text-decoration: none;
			background-color: #FFFFFF;
    		color: #3A4FFF;
			border-color: #3A4FFF;
			text-align: start;
			font-size: 12px;
			font-weight: 400 !important;
		}
		.ant-btn-primary:hover {
			background-color: #3A4FFF;
			color: #FFFFFF;
		}
	}
	@media(max-width: 960px) {
		padding: 10px;
	}
`;

export const HelpWrapper = styled.div`
	.user-info {
		${Wrapper}
`;

export default Wrapper;
